export const errorLogger = error => {
  if (DEPLOY_ENV !== 'production' || DEPLOY_ENV !== 'staging') {
    console.error(error)
    return
  }
  throw error
}
